export default __webpack_public_path__ + "static/media/biofit-builder-series-CX.95f28dbf.png";